// extracted by mini-css-extract-plugin
module.exports = {"keyVisualImage":"SkeletonKeyVisual_keyVisualImage___snPC","image":"SkeletonKeyVisual_image__QTy7_"};